import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core';
import { memoize } from 'lodash';

import { MapMarkerComponent, MapPlantSuggestlistComponent, MapPolylineComponent, plantIcon, QPointMapPolyline, siteBeginIcon } from '../../../../projects/qpoint-maps/src/public_api';
import { MapComponent as QPointMapComponent } from "../../../../projects/qpoint-maps/src/lib/components/map/map.component";

@Component({
    selector: 'app-map-qsite-roundtripplanning',
    imports: [
        CommonModule,
        MapPlantSuggestlistComponent,
        MapMarkerComponent,
        MapPolylineComponent,
        QPointMapComponent
    ],
    templateUrl: './map-qsite-roundtripplanning-test.component.html',
    styleUrls: ['./map-qsite-roundtripplanning-test.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapQSiteRoundTripPlanningTestComponent {

  showPlantSelector = signal<boolean>(true);

  sitePoi = signal({
    position: { lat: 46.69407594, lng: 16.11388167 },
    icon: siteBeginIcon(),
    draggable: false
  })

  plantPois = signal([
    {
      position: { lat: 46.54627000000001, lng: 16.27279 },
      icon: plantIcon(),
      draggable: false
    }
  ])

  routeDragMarker = computed<google.maps.MarkerOptions>(() => {
    return null;
  })

  waypointIcon: google.maps.MarkerOptions = {
    draggable: true,
    title: 'dragToChange',
    icon: {
      path: google.maps.SymbolPath.CIRCLE,
      scale: 6,
      fillColor: 'white',
      fillOpacity: 1,
      strokeColor: 'black',
      strokeWeight: 2,
    },
    zIndex: 100
  }

  mapModes = [
    {
      mode: 'polyline',
      icon: 'up-right',
      iconType: 'solid',
      multi: false,
      scope: 'toSite',
      active: false,
      tooltip: 'editToSite',
      disabled: false
    },
    {
      mode: 'polyline',
      icon: 'down-right',
      iconType: 'solid',
      multi: false,
      scope: 'toPlant',
      active: false,
      tooltip: 'editToPlant',
      disabled: false
    },
  ];
  selectedPlantId: string = '1234';

  plantsWithRoutes = signal([{
      id: '1234',
      name: 'Plant 1',
    }]);

  activeMode = signal(this.mapModes[0]);

  activeRouteTo = signal({
    type: 'LineString',
    scope: 'toSite',
    coordinates: [
      [
        16.11388167,
        46.69407594
      ],
      [
        16.205413,
        46.634757
      ],
      [
        16.27279,
        46.54627000000001
      ]
    ]
  });

  activeRouteToWaypoints = signal({
    type: 'MultiPoint',
    coordinates: [
      [
        16.205413,
        46.634757
      ]
    ]
  });

  asMarker = memoize((coordinates: QPointMapPolyline["coordinates"]) => {
    return (coordinates || []).map(c => {
      return {
        ...this.waypointIcon,
        position: new google.maps.LatLng(c[1], c[0])
      }
    })
  })

  transportRoutesForMap = computed(() => {
    const routes =
    [
      {
        routeToSite: {
          type: 'LineString',
          coordinates: [
            [
              16.11388167,
              46.69407594
            ],
            [
              16.205413,
              46.634757
            ],
            [
              16.27279,
              46.54627000000001
            ]
          ]
        },
        routeToSiteColor: '#0000ff80',
        routeToPlant: {
          type: 'LineString',
          coordinates: [
            [
              16.11388167,
              46.69407594
            ],
            [
              16.205413,
              46.644757
            ],
            [
              16.27279,
              46.54627000000001
            ]
          ]
        },
        routeToPlantColor: '#ff000080',
      }
    ];
    return routes;
});

  setActiveMode(event) {
    console.log('setActiveMode', event);
  }

  handleMapClick() {
    console.log('handleMapClick');
  }

  plantChanged(event) {
    console.log('plantChanged', event);
  }

  onMouseOut(event) {
    console.log('onMouseOut', event);
  }

  onMouseMove(event) {
    console.log('onMouseMove', event);
  }

  handleMarkerChange(event) {
    console.log('handleMarkerChange', event);
  }

  handleMarkerRightClick(event) {
    console.log('handleMarkerRightClick', event);
  }

  resetMarkerMenu() {
    console.log('resetMarkerMenu');
  }
}
